import React from 'react';
import { Search01Icon } from 'hugeicons-react';

export const SearchEmptyState: React.FC = () => {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        <Search01Icon size={48}/>
        <div className="empty-state-icon-glow"></div>
      </div>
      <h3>No results found</h3>
      <p>Try different keywords or check your spelling</p>
      <div className="search-suggestions">
        <span className="suggestion-chip">class notes</span>
        <span className="suggestion-chip">today</span>
        <span className="suggestion-chip">yesterday</span>
      </div>
    </div>
  );
};

interface SearchInitialStateProps {
  onNewChat: () => void;
}

export const SearchInitialState: React.FC<SearchInitialStateProps> = ({ onNewChat }) => {
  return (
    <>
      <div className='search-result-item new-chat' onClick={onNewChat}>
        <div className="new-chat-content">
          <Search01Icon size={20}/>
          <span className="new-chat-title">New Chat</span>
        </div>
      </div>
      <div className='search-examples-listings'>
        <p>Type in the search bar to find messages, conversations, and topics you've discussed</p>
        <div className="search-examples">
          <div className="search-example-item">
            <Search01Icon size={16}/>
            <span>Project deadline</span>
          </div>
          <div className="search-example-item">
            <Search01Icon size={16}/>
            <span>Meeting notes</span>
          </div>
          <div className="search-example-item">
            <Search01Icon size={16}/>
            <span>AI suggestions</span>
          </div>
          <div className="search-example-item">
            <Search01Icon size={16}/>
            <span>Homework help</span>
          </div>
          <div className="search-example-item">
            <Search01Icon size={16}/>
            <span>Book recommendations</span>
          </div>
        </div>
      </div>
    </>
  );
};